/**
 * The current login's session family id (ADR-018, Decision 5; Phase G-7,
 * Job 9). Not a bearer credential by itself - it identifies which of the
 * account's `AuthSession` rows is "this device", so the session-management
 * page can mark it as current and the backend can accept
 * `DELETE /auth/sessions/others` without the caller needing to know its own
 * id in advance. Revoking a session still requires a valid Bearer access
 * token AND the target session to belong to that same user
 * (session.service.ts's `revokeSession`), so this value leaking on its own
 * grants nothing.
 *
 * `sessionStorage` only, its own dedicated key - same discipline as
 * lib/api/auth-token.ts. Set once at login (a token refresh keeps the same
 * family id, so it never needs re-syncing), cleared on logout.
 */

const STORAGE_KEY = 'mahfuz.sessionFamilyId';

export function setSessionFamilyId(familyId: string): void {
  sessionStorage.setItem(STORAGE_KEY, familyId);
}

export function getSessionFamilyId(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearSessionFamilyId(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
